import styled from "@emotion/styled";

export const UpdateIndicator = styled.div`
  display: inline-block;

  inline-size: 6px;
  block-size: 6px;
  margin-inline-start: 3px;

  vertical-align: top;

  border-radius: 50%;

  background: #eb4254;
  aspect-ratio: 1 / 1;
`;
